/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { Spacer, Button, sizes } from '@smartsheet/lodestar-core';
import { AddIcon } from '@smartsheet/lodestar-icons';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { setIsUpsertScheduleVisible, selectIsUpsertScheduleVisible } from '../../../../../../services/ducks/schedulesDuck';
import { ListSchedules } from './ListSchedules';

const addButtonContainerStyle = css`
  margin-top: ${sizes.medium}px;
`;

export const SchedulesHome = () => {
  const { t: translate } = useTranslation();
  const dispatch = useDispatch();

  const isUpsertScheduleVisible = useSelector(selectIsUpsertScheduleVisible);
  return (
    <Spacer orientation="column" space="large">
      {isUpsertScheduleVisible ? null : (
        <div css={addButtonContainerStyle}>
          <Button
            appearance="secondary"
            size="medium"
            onClick={() => {
              dispatch(setIsUpsertScheduleVisible(true));
            }}
            iconBefore={<AddIcon size="small" />}
          >
            {translate('designer:triggerPanel:schedules:addNewSchedule')}
          </Button>
        </div>
      )}
      <ListSchedules />
    </Spacer>
  );
};
